var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn-lg btn-link",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _setup.router.go(-1)
          },
        },
      },
      [
        _c("i", {
          staticClass: "fa fa-arrow-left",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Back")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          "min-width": "700px",
          width: "60vw",
          margin: "auto",
          "margin-top": "40px",
        },
      },
      [
        _c("h2", { staticClass: "fg-color-blue" }, [_vm._v("Access tokens")]),
        _vm._v(" "),
        _c("hr"),
        _c("br"),
        _vm._v(" "),
        _setup.succeedUserAccessTokensQueryV1
          ? _c(
              "div",
              { staticClass: "border-box" },
              [
                _setup.accessTokens.length == 0
                  ? _c("h4", [_vm._v("No access tokens generated")])
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm._l(_setup.accessTokens, function (token) {
                  return _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-default",
                          attrs: {
                            type: "button",
                            title: "Revoke access token",
                          },
                          on: {
                            click: function ($event) {
                              return _setup.handleRevokeAccessTokenCommandV1(
                                token
                              )
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa-solid fa-ban" })]
                      ),
                      _vm._v(" "),
                      token.IsExpired || token.IsRevoked
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "text-decoration": "line-through",
                              },
                            },
                            [_vm._v(_vm._s(token.Name))]
                          )
                        : _c("span", [_vm._v(_vm._s(token.Name))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _vm._v(_vm._s(token.ExpireAt)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _vm._v(_vm._s(token.Id)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      token.Id == _setup.id
                        ? _c(
                            "div",
                            { staticClass: "input-group input-group-sm" },
                            [
                              _c("input", {
                                staticClass: "form-control bg-white",
                                class: { "text-success": _setup.copied },
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value: _setup.copied
                                    ? "COPIED!"
                                    : _setup.accessToken,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: { click: _setup.handleCopyToClipboard },
                                  },
                                  [_c("span", { staticClass: "fa fa-copy" })]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _setup.handleGenerateAccessTokenCommandV1 },
                  },
                  [_vm._v("Generate a new token")]
                ),
              ],
              2
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [_c("strong", [_vm._v("Name")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [_c("strong", [_vm._v("Expiration")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [_c("strong", [_vm._v("ID")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [_c("strong", [_vm._v("Secret")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }